var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useGetOne, CRUD_GET_ONE } from 'react-admin';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import { ENTITY_TYPE_CUSTOM } from '../dataProvider/documents';
import { CurrentUserId } from '../dataProvider/userContexts';
import { isPortalAdmin } from '../userContexts';
import { Documentation } from './Documentation';
import { DocumentTitle } from './DocumentTitle';
import { ViewTitle } from '../ui';
export const DocumentList = (_a) => {
    var { title = React.createElement(DocumentTitle, null) } = _a, props = __rest(_a, ["title"]);
    const classes = useStyles(props);
    const { data: userContexts } = useGetOne('userContexts', CurrentUserId, {
        action: CRUD_GET_ONE,
    });
    const isAdmin = isPortalAdmin(userContexts);
    const userCanDelete = isAdmin;
    const userCanEdit = isAdmin;
    return (React.createElement(React.Fragment, null,
        React.createElement(ViewTitle, null, title),
        React.createElement(Paper, { className: classes.root },
            React.createElement(Documentation, { entityType: ENTITY_TYPE_CUSTOM, entityUuid: "wiki1", userCanDelete: userCanDelete, userCanEdit: userCanEdit }))));
};
const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2),
        flexGrow: 1,
    },
}), {
    name: 'Layer7DocumentList',
});
//# sourceMappingURL=DocumentList.js.map